
























































































// tslint:disable-next-line:no-unused
import Vue, { CreateElement, VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { Slots } from '@vue/test-utils';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { dropdown, DropdownDirValues } from '@libs-uuif/shared/dropdown-dir';
import CustomDropdownUnit from './custom-dropdown-unit.vue';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { domService } from '@libs-uuif/shared/dom-service';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';

const cssPrefix: string = 'custom-dropdown';

@Component({
  directives: {
    dropdown,
  },
  components: {
    SwIcon,
    SwTextfield,
    CustomDropdownUnit,
    SwIconButton,
  },
})
export default class CustomDropdown extends SwExtendedVue {
  cssPrefix = cssPrefix;
  dropdownOpen: boolean = false;
  slots: Slots;
  width: number = 180; // in order to get the width changing reactive

  @Prop({ required: true, type: [String, Number, Boolean] })
  dropdownLabel: string | number | boolean;

  @Prop()
  options: String[];

  @Prop()
  limit: number;

  @Prop()
  clearable: boolean;

  // tslint:disable-next-line:no-unused
  clickOutside(e: EventListener) {}

  dropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  get focusPopoverValue(): DropdownDirValues {
    // tslint:disable-next-line:block-spacing
    return {
      /* tslint:disable */
      content: (h: CreateElement) => {
        return (
          <div
            ref="dropdowncontainerRef"
          >
            <div
              style="padding:10px; padding-top:10px"
            >
              <CustomDropdownUnit
                onOptionClicked={this.optionSelected}
                options={this.options}
                limit={this.limit}
              ></CustomDropdownUnit>
            </div>
          </div>
        ) as VNode;
      },
      trigger: "controlled",
      visible: this.dropdownOpen,
      placement: "bottom",
      withArrow: false,
      maxHeight: 1000,
      width: this.width,
      onClickOutsidePopper: () => {
        this.dropdownOpen = false;
      }
    };
  }

  optionSelected(selectedVal: string) {
    this.dropdown();
    this.$emit("optionSelection", selectedVal);
  }
  clearSelection(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    this.$emit('clearSelection');
  }

  private updateSizes() {
    this.width = (this.$el as HTMLElement).offsetWidth;
  }

  mounted() {
    this.$nextTick(() => {
      this.updateSizes();
    });
    domService.resizeObserver.on(this.$el as HTMLElement, this.updateSizes);
  }
}
